import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://synergitech.com.au";

export const socket = io(SOCKET_URL, {
  path: "/socket.io",
  reconnectionAttempts: 5,
  transports: ["websocket"],
  autoConnect: false,
})